// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-items_container__DoEP5","clean":"cart-items_clean__teKmO"};